export default defineAppConfig({
  ui: {
    primary: "sb-purple",
    button: {
      variant: {
        solid: "dark:text-white",
      },
    },
    badge: {
      variant: {
        solid: "dark:text-white",
      },
    },
    chip: {
      base: "dark:text-white",
    },
  },
});
